import { type AllCoverablesOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { type ProductStatus } from '../../recoil/types/onsaTypes';
import ContentNumberOfClaimsStep from './privateContent/ContentNumberOfClaimsStep';
import ContentTypeOfClaimStep from './privateContent/ContentTypeOfClaimStep';
import PrhNumberOfClaimsStep from './HouseHolidayHome/PrhNumberOfClaimsStep';
import PrhTypeOfClaimStep from './HouseHolidayHome/PrhTypeOfClaimAndClaimAmountStep';

type ClaimsHistoryConfig = Array<{
    id: string;
    disabled?: boolean;
    Component: React.ComponentType<{
        goNext: () => void;
        goPrevious: () => void;
    }>;
}>;

export const getClaimsHistoryConfig = (
    currentProduct: ProductStatus,
    coverables: AllCoverablesOnsaDTO
): ClaimsHistoryConfig => {
    switch (currentProduct?.flavourName) {
        case 'Indboforsikring':
            return getPrivateContentConfig(coverables, currentProduct);
        case 'Indboforsikring til unge':
            return getYouthContentConfig(coverables, currentProduct);
        case 'Husforsikring':
        case 'Fritidshusforsikring':
            return getHouseHolidayHomeConfig(coverables, currentProduct);
        default:
            return [];
    }
};
const getHouseHolidayHomeConfig = (
    coverables: AllCoverablesOnsaDTO,
    currentProduct: ProductStatus
): ClaimsHistoryConfig => {
    const coverable =
        coverables.houses?.find((element) => element.fixedId === currentProduct.fixedId) ??
        coverables.holidayHomes?.find((element) => element.fixedId === currentProduct.fixedId);
    const buyingHouse = coverable?.buyingHouse === 'Ja';
    return [
        {
            id: 'PrhNumberOfClaimsStep',
            Component: PrhNumberOfClaimsStep,
            disabled: buyingHouse
        },
        {
            id: 'PrhTypeOfClaimStep',
            Component: PrhTypeOfClaimStep,
            disabled: coverable?.numberOfClaims === 0 || buyingHouse
        }
    ];
};

const getPrivateContentConfig = (
    coverables: AllCoverablesOnsaDTO,
    currentProduct: ProductStatus
): ClaimsHistoryConfig => {
    const coverable = coverables.privateContent?.find(
        (element) => element.fixedId === currentProduct.fixedId
    );
    return [
        {
            id: 'ContentNumberOfClaimsStep',
            Component: ContentNumberOfClaimsStep
        },
        {
            id: 'ContentTypeOfClaimStep',
            Component: ContentTypeOfClaimStep,
            disabled: coverable?.numberOfClaims === 0
        }
    ];
};

const getYouthContentConfig = (
    coverables: AllCoverablesOnsaDTO,
    currentProduct: ProductStatus
): ClaimsHistoryConfig => {
    const coverable = coverables.youthContent?.find(
        (element) => element.fixedId === currentProduct.fixedId
    );
    return [
        {
            id: 'ContentNumberOfClaimsStep',
            Component: ContentNumberOfClaimsStep
        },
        {
            id: 'ContentTypeOfClaimStep',
            Component: ContentTypeOfClaimStep,
            disabled: coverable?.numberOfClaims === 0
        }
    ];
};
